import Report from 'modules/reports/models/Report'
import ListEndpoint from 'modules/reports/orm/endpoints/ListEndpoint'

export type ListReportsByUserRequest = {
  userId: number
  folder_id: number | 'all'
}

class ListReportEndpoint extends ListEndpoint<ListReportsByUserRequest, Report> {
  model = Report
  alternativeApiUrl = process.env.REACT_APP_ALTERNATIVE_REPORTS_API_URL

  urlParams = ['userId']

  cleanupRequestData(data: ListReportsByUserRequest) {
    const newData = {...data}
    if (data.folder_id === 'all') delete newData.folder_id

    return newData
  }

  buildPath(request: ListReportsByUserRequest) {
    return `users/${request.userId}/reports`
  }
}

export default new ListReportEndpoint().fetch
